import { IDepartment } from "@/types/department";
import { MasterData } from "./masterData";

export class Department extends MasterData implements IDepartment {
  public readonly company_id = 0;
}
